<template>
  <div>
    <h4><strong>Parcelas</strong></h4>
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="installments-config">
          <div class="installments-config__item">
            <strong>Quantidade: </strong>
            <select
              class="form-control installments-config__input js-installments-select"
              v-model="options.installments"
              @change="$emit('change', options)"
            >
              <option v-for="index in maxInstallments" :key="index" :value="index">
                {{ index }}
              </option>
            </select>
          </div>
          <div v-if="showDates" class="installments-config__item">
            <strong class="installments-config__input">Início: </strong>
            <date-picker
              :config="datePickerOptions"
              v-model="options.startDate"
              placeholder="Data"
              class="installments-config__input js-date-input"
              @change.native="$emit('change', options)"
            />
          </div>
        </div>
      </div>

      <table class="table table-striped" v-if="showTable">
        <thead>
          <tr>
            <th>#</th>
            <th>Valor</th>
            <th v-if="showDates">
              Vencimento
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="index in options.installments" :key="index">
            <td>{{ index }}</td>
            <td>
              {{ installmentValue | formatCurrency }}
            </td>
            <td v-if="showDates">
              {{ getDate(index - 1) | formatDate }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import 'moment/locale/pt-br';
import DatePicker from 'vue-bootstrap-datetimepicker';
import datePickerOptions from 'utils/DatePickerOptions';

export default {
  components: {
    DatePicker,
  },
  props: {
    fullValue: {
      type: Number,
      required: true,
    },
    paymentMethod: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      options: {
        installments: 0,
        startDate: null,
      },
      datePickerOptions,
    };
  },
  computed: {
    installmentValue() {
      return parseFloat((this.fullValue / this.options.installments).toFixed(2));
    },
    parsedInstallmentsStartDate() {
      return moment(this.options.startDate, 'DD/MM/YYYY');
    },
    maxInstallments() {
      return this.paymentMethod === 'card' ? 12 : 10;
    },
    showDates() {
      return this.paymentMethod !== 'card';
    },
    showTable() {
      return !!this.options.installments && (this.showDates ? !!this.options.startDate : true);
    },
  },
  methods: {
    getDate(index) {
      return this.parsedInstallmentsStartDate.clone().add(index, 'months').format('YYYY-MM-DD');
    },
  },
};
</script>

<style lang="scss" scoped>
.installments-config {
  align-items: center;
  display: flex;
}

.installments-config__item {
  align-items: center;
  display: flex;
  position: relative;
}

.installments-config__input {
  margin-left: 8px;
  max-width: 180px;
}
</style>
